import MailWithCheckSvg from '@assets/images/svg/mail-with-check.svg';
import React from 'react';
import { View } from 'react-native';

export interface MailWithCheckIconProps {
  size?: number;
  color?: string;
}

const ASPECT = 11 / 13;

/**
 * Mail + check (Figma reservation “booking form via email” step).
 * Default color matches original SVG fill (#333333).
 */
export function MailWithCheckIcon({
  size = 16,
  color = '#333333',
}: Readonly<MailWithCheckIconProps>) {
  const width = size;
  const height = size * ASPECT;

  return (
    <View
      style={{
        width,
        height,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <MailWithCheckSvg width={width} height={height} color={color} />
    </View>
  );
}

export default MailWithCheckIcon;
